export const FeatureResponseDefault = {};